module.exports = __webpack_public_path__ + "img/man-ico.3ef1ac7e.svg";